import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=6640db90&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6640db90')) {
      api.createRecord('6640db90', component.options)
    } else {
      api.reload('6640db90', component.options)
    }
    module.hot.accept("./tracking.vue?vue&type=template&id=6640db90&", function () {
      api.rerender('6640db90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/tabs/tracking.vue"
export default component.exports